// extracted by mini-css-extract-plugin
export default {"input":"RadioButton_input__JoGRy","label":"RadioButton_label__7mG1v"};